<template>
    <div class="gofixInput gofixTextAreaInput" v-bind:class="{gofixInputHasDesc:desc,gofixInputError : (required && !value && blurInput),gofixInputDisable:disabled && showClassDisabled}">
        <div class="mainInput">
            <textarea :value="value"
                      :disabled="disabled"
                      :rows="rows"
                      @change="handleChange"
                      @input="handleInput"
                      v-on:keyup="handleInput"
                      v-on:blur="blurInput = true"
            v-bind:class="[classTextarea, {hasValue:value}]"></textarea>
            <div class="label">{{label}}<span class="iconRequired" v-if="showIconRequired && required">*</span></div>
        </div>
        <p class="desc" v-if="desc" v-html="desc"></p>
    </div>
</template>

<script>
    export default {
        name: "textarea-input",
        props: {
            desc: {
                type: String,
                required: false,
                default: () => null
            },
            required: {
                type: Boolean,
                required: false,
                default: () => false
            },
            label: {
                type: String,
                required: false,
                default: () => "Label"
            },
            rows: {
                type: Number,
                required: false,
                default: () => 2
            },
            value: {
                default: () => null
            },

            disabled: {
                type: Boolean,
                default: false
            },
            showIconRequired: {
                type: Boolean,
                required: false,
                default: () => false
            },
            mode: {
                type: String,
                required: false,
                default: () => "single"
            },
            placeholder: {
                type: String,
                required: false,
                default: () => null
            },
            popoverDirection: {
                type: String,
                required: false,
                default: () => "bottom"
            },
            popoverVisibility: {
                type: String,
                required: false,
                default: () => "focus"
            },
            showClassDisabled: {
                type: Boolean,
                required: false,
                default: true
            },
            classTextarea: {
                type: String,
                required: false,
                default: () => null
            }
        },

        data() {
            return {
                blurInput:false,
                openPopover:false,
            }
        },
        watch: {


        },
        created(){

        },
        methods: {
            handleInput (e) {
                this.$emit("input", e.target.value);
            },
            handleChange (e) {
                this.$emit("change", e.target.value);
            },
            openDatePopover(){
                this.openPopover = true;
            },
            hideDatePopover(){
                this.openPopover = false;
                this.blurInput = true;
            }
        }
    }
</script>
